import gql from 'graphql-tag'

export const GET_USER_SHIFT_HISTORY_COMPUTED_PAGINATION_QUERY = gql`
  query GetUserShiftHistoryComputedPagination (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getUserGroupShiftHistoryComputedPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        payment
        hours
        from
        userGroupShift {
          id
          userGroupAlt
          userShift {
            alt
            coefficient
          }
        }
        currencyTitle
      }
    }
  }
`
